import { connect } from 'react-redux';
import { IAuthSettingsState } from '@piwikpro/auth-crate/reducers/auth';
import { withTranslation } from '@piwikpro/ui-components';
import TwoFactorConfigure from './TwoFactorConfigure';

export default withTranslation(['administration'])(
  connect(
    (state: { authSettings: IAuthSettingsState }) => ({
      isLoading: state.authSettings.user.setup.isLoading,
      failed: state.authSettings.user.setup.failed,
      failReason: state.authSettings.user.setup.failReason,
      data: state.authSettings.user.setup.data,
      twoFactorAuthEnabled: state.authSettings.user.twoFactorAuth.enabled,
      isResetFlow: state.authSettings.user.twoFactorAuth.enforced,
    }),
    null,
  )(TwoFactorConfigure),
);
